import React from "react";
import { Statistic, Row, Col, Skeleton } from "antd";
import {
  DollarOutlined,
  BankOutlined,
  CreditCardOutlined,
  WalletOutlined,
} from "@ant-design/icons";

import { formatCLP, normalizeRecaudacion } from "../../utils/routeMonitoring";

const methodConfig = [
  { key: "Efectivo", label: "Efectivo", icon: <DollarOutlined />, color: "#3f8600" },
  { key: "Transferencia", label: "Transferencia", icon: <BankOutlined />, color: "#1677ff" },
  { key: "Tarjeta", label: "Tarjeta", icon: <CreditCardOutlined />, color: "#9254de" },
];

// Renders total collected + the Efectivo/Transferencia/Tarjeta breakdown for
// a `{ recaudacion, total }` payload shaped like the driver-summary endpoint response.
const PaymentBreakdown = ({ recaudacion, total, loading, size = "default" }) => {
  if (loading) {
    return <Skeleton active title={false} paragraph={{ rows: 1 }} />;
  }

  const byMethod = normalizeRecaudacion(recaudacion);
  const valueStyle =
    size === "small" ? { fontSize: 14 } : { fontSize: 20, fontWeight: 600 };

  return (
    <div>
      <Statistic
        title="Recaudado"
        value={formatCLP(total)}
        prefix={<WalletOutlined />}
        valueStyle={valueStyle}
      />
      <Row gutter={8} className="mt-2">
        {methodConfig.map(({ key, label, icon, color }) => (
          <Col span={8} key={key}>
            <Statistic
              title={label}
              value={formatCLP(byMethod[key])}
              prefix={icon}
              valueStyle={{ fontSize: size === "small" ? 12 : 14, color }}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default PaymentBreakdown;
